export const parseThumbnail = thumbnailUrl => {
  if (!thumbnailUrl) {
    return thumbnailUrl
  }

  const re = /(.*)-150x150(.*)/
  const newUrl = thumbnailUrl.replace(re, "$1$2")
  return newUrl
}
